import { useApi } from '@api/ApiProvider'
import { useI18n } from '@i18n/I18nProvider'
import { useQuery } from '@tanstack/react-query'

export const useSpeciesList = () => {
	const api = useApi()
	const { locale } = useI18n()
	return useQuery({ queryKey: ['species', locale], queryFn: () => api.speciesList(locale) })
}

export const speciesQueryKey = (id: string, locale: string) => ['species', id, locale] as const

export const useSpecies = (id: string) => {
	const api = useApi()
	const { locale } = useI18n()
	return useQuery({ queryKey: speciesQueryKey(id, locale), queryFn: () => api.species(id, locale) })
}

// Con `regionId`, la ficha se abre por la pestaña de esa comunidad (`?comunidad=15`).
export const speciesHref = (id: string, regionId?: string) =>
	`/formacion/especies/${encodeURIComponent(id)}${regionId ? `?${new URLSearchParams({ comunidad: regionId })}` : ''}`

// La comunidad pedida en la URL de la ficha; null si no viene.
export const regionFromSearch = (search: string): string | null =>
	new URLSearchParams(search).get('comunidad')?.trim() || null
